import apiSlice from "./ApiSlice";

export const installmentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET
    getInstallments: builder.query({
      providesTags: ["pay-installment", "installment"],
      query: (body) => {
        return {
          url: "/installment",
          method: "POST",
          body,
        };
      },
      keepUnusedDataFor: 0,
    }),

    // GET BY ID
    getInstallmentById: builder.query({
      query: (installmentId) => {
        return {
          url: `/installment/${installmentId}`,
          method: "GET",
        };
      },
      keepUnusedDataFor: 0,
    }),

    // Pay Installment
    payInstallment: builder.mutation({
      invalidatesTags: ["pay-installment"],
      query: ({
        body,
        installmentId,
      }: {
        body: any;
        installmentId: string;
      }) => {
        return {
          url: `/installment/${installmentId}`,
          method: "PUT",
          body,
        };
      },
    }),

    // ADD
    addInstallment: builder.mutation({
      invalidatesTags: ["student"],
      query: (body) => {
        return {
          url: "/installment/add",
          method: "POST",
          body,
        };
      },
    }),

    // EDIT
    editInstallment: builder.mutation({
      invalidatesTags: ["installment"],
      query: (body) => {
        return {
          url: "/installment/update-installments",
          method: "PUT",
          body,
        };
      },
    }),
  }),
});

export const {
  useGetInstallmentsQuery,
  useGetInstallmentByIdQuery,
  usePayInstallmentMutation,
  useAddInstallmentMutation,
  useEditInstallmentMutation,
} = installmentApi;
